<template>
  <div>
    <!-- Page Title -->
    <div class="page-title-area">
      <div class="d-table">
        <div class="d-table-cell">
          <div class="container">
            <h2>Our Services</h2>
          </div>
        </div>
      </div>
      
      <div class="shape1"><img src="/img/shape1.png" alt="shape"></div>
      <div class="shape2 rotateme"><img src="/img/shape2.svg" alt="shape"></div>
      <div class="shape3"><img src="/img/shape3.svg" alt="shape"></div>
      <div class="shape4"><img src="/img/shape4.svg" alt="shape"></div>
      <div class="shape5"><img src="/img/shape5.png" alt="shape"></div>
      <div class="shape6 rotateme"><img src="/img/shape4.svg" alt="shape"></div>
      <div class="shape7"><img src="/img/shape4.svg" alt="shape"></div>
      <div class="shape8 rotateme"><img src="/img/shape2.svg" alt="shape"></div>
    </div>
    <!-- End Page Title -->
    
    <!-- Services Area -->
    <section class="services-area-two ptb-80 bg-f9f6f6">
      <div class="container">
        <div class="section-title">
          <h2>Enterprise Solutions</h2>
          <div class="bar"></div>
          <p>Our comprehensive suite of enterprise services designed to meet your business needs with scalable and secure solutions.</p>
        </div>
                
        <div class="row">
          <div v-for="service in services" :key="service.id" class="col-lg-4 col-md-6">
            <div :id="service.id" class="single-services-box">
              <div class="icon">
                <i :data-feather="service.icon"></i>
              </div>
              <h3>{{ service.name }}</h3>
              <p>{{ service.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End Services Area -->
  </div>
</template>

<script>
import { onMounted, ref } from 'vue'
import { updateMetaTags, addStructuredData } from '../utils/seo'

export default {
  name: 'ServicesPage',
  setup() {
    // Define services
    const services = ref([
      {
        id: 'content-management',
        name: 'Content Management',
        description: 'Enterprise-grade content management system with advanced workflows, multi-language support, and scalable architecture for all your content needs.',
        icon: 'edit-3'
      },
      {
        id: 'drive',
        name: 'Drive',
        description: 'Secure file storage and sharing solution with enterprise-level permissions, versioning, and integration capabilities for your business data.',
        icon: 'hard-drive'
      },
      {
        id: 'kakari',
        name: 'Kakari Global Management',
        description: 'Comprehensive global management platform for handling distributed systems, international markets, and multi-region regulatory compliance.',
        icon: 'globe'
      },
      {
        id: 'mailing-lists',
        name: 'Mailing Lists',
        description: 'Advanced email marketing and list management with automated workflows, campaign analytics, and seamless integration with your business systems.',
        icon: 'mail'
      },
      {
        id: 'telephony',
        name: 'Telephony',
        description: 'Enterprise telephony services including VoIP, IVR systems, call routing, and global telecommunications infrastructure to keep your business connected.',
        icon: 'phone'
      },
      {
        id: 'api-integration',
        name: 'API Integration',
        description: 'Comprehensive REST API services with extensive documentation, flexible authentication methods, and seamless integration options for your custom solutions.',
        icon: 'code'
      }
    ])

    onMounted(() => {
      // Initialize feather icons
      if (window.feather) {
        window.feather.replace()
      }
      
      // Set SEO meta tags
      updateMetaTags({
        title: 'Enterprise Services | AtOnline',
        description: 'Explore our comprehensive suite of enterprise solutions including content management, file storage, global management, mailing lists, and telephony services.',
        keywords: 'content management system, file storage, kakari global management, mailing lists, telephony services, api integration',
        type: 'website',
        url: window.location.href
      })
      
      // Add structured data
      addStructuredData({
        "@context": "https://schema.org",
        "@type": "ItemList",
        "itemListElement": services.value.map((service, index) => ({
          "@type": "ListItem",
          "position": index + 1,
          "item": {
            "@type": "Service",
            "name": service.name,
            "description": service.description,
            "url": `https://www.atonline.com/services#${service.id}`,
            "provider": {
              "@type": "Organization",
              "name": "AtOnline",
              "url": "https://www.atonline.com",
              "parentOrganization": {
                "@type": "Organization",
                "name": "Karpeles Lab Inc",
                "url": "https://klb.jp"
              }
            }
          }
        }))
      })
    })
    
    return {
      services
    }
  }
}
</script>

<style scoped>
/* Services page specific styles */
</style>